export default __webpack_public_path__ + "static/media/my-bg.a8a7f169.png";